import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

const PAGE_WIDTH_IN = 8.5;
const PAGE_HEIGHT_IN = 13;
const MARGIN_IN = 0.5;
const CONTENT_WIDTH_IN = PAGE_WIDTH_IN - MARGIN_IN * 2;
const CONTENT_HEIGHT_IN = PAGE_HEIGHT_IN - MARGIN_IN * 2;

// Renders the given DOM node to a PDF sized exactly 8.5in x 13in, bypassing the
// browser's print dialog entirely — so there's no built-in date/title/URL/page-number
// header or footer to worry about, since we never call window.print().
export async function downloadReportPdf(element, filename = 'report.pdf') {
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
  });

  const imgData = canvas.toDataURL('image/png');
  const imgHeightIn = (canvas.height * CONTENT_WIDTH_IN) / canvas.width;

  const pdf = new jsPDF({ unit: 'in', format: [PAGE_WIDTH_IN, PAGE_HEIGHT_IN] });

  let heightLeft = imgHeightIn;
  let position = 0;

  pdf.addImage(imgData, 'PNG', MARGIN_IN, MARGIN_IN - position, CONTENT_WIDTH_IN, imgHeightIn);
  heightLeft -= CONTENT_HEIGHT_IN;

  while (heightLeft > 0) {
    position += CONTENT_HEIGHT_IN;
    pdf.addPage([PAGE_WIDTH_IN, PAGE_HEIGHT_IN], 'portrait');
    pdf.addImage(imgData, 'PNG', MARGIN_IN, MARGIN_IN - position, CONTENT_WIDTH_IN, imgHeightIn);
    heightLeft -= CONTENT_HEIGHT_IN;
  }

  pdf.save(filename);
}
